import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider, { Settings } from 'react-slick';
import { useEffect, useRef } from 'react';
import ScheduleTreatmentEventModel from './model';

type ScheduleTreatmentEventsViewModelProps = {
  days: Date[];
  setSelectedDay: (day: Date | null | undefined) => void;
  selectedDay?: Date | null;
};
export default function ScheduleTreatmentEventsViewModel({
  days,
  setSelectedDay,
  selectedDay
}: ScheduleTreatmentEventsViewModelProps) {
  const ref = useRef<Slider>(null);
  const model = new ScheduleTreatmentEventModel({ days });

  const settings: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false
  };

  const next = () => {
    ref.current?.slickNext();
  };
  const prev = () => {
    ref.current?.slickPrev();
  };

  useEffect(() => {
    const [currentDay, index] = model.selectCurrentDay(new Date()) || [null, -1];
    if (index === -1) {
      setSelectedDay(days[0]);
    } else {
      setSelectedDay(currentDay);
      ref.current?.slickGoTo(index);
    }
  }, [days]);

  useEffect(() => {
    if (!selectedDay) return;
    setSelectedDay(selectedDay);
  }, [selectedDay]);

  return {
    settings,
    Slider,
    next,
    prev,
    ref,
    formatDateToDisplayDayOfWeek: model.formatDateToDisplayDayOfWeek,
    formatTimeToDisplayDayOfMonthTwoDigits: model.formatTimeToDisplayDayOfMonthTwoDigits
  };
}
